import type { Selection } from '@atlaskit/editor-prosemirror/state';
import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';
import { publish } from '@atlaskit/rovo-triggers/main';

// Keeps the Rovo Remix picker in sync with the current editor scope.
export const publishEditorRemixPreset = (selection: Selection): void => {
	if (
		UNSAFE_expValNoExposure('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') !==
		'variant2'
	) {
		return;
	}

	const remixPreset = selection.empty ? 'page' : 'selection';
	publish('rovo-remix', {
		type: 'update-rovo-remix-preset',
		source: 'editor-selection',
		openChat: false,
		data: { remixConsumer: 'editor', remixPreset },
	});
};
